import { AssetViewerConfig } from '../types';

export const setupKeyboardNavigation = (
  config: AssetViewerConfig,
  isOpen: boolean,
  onPrevious: () => void,
  onNext: () => void,
  onClose: () => void
) => {
  if (!config.navigation.enableKeyboard) return;

  const handleKeyDown = (e: KeyboardEvent) => {
    if (!isOpen) return;

    const { keyBindings } = config.navigation;

    if (e.key === keyBindings.previous) onPrevious();
    if (e.key === keyBindings.next) onNext();
    if (e.key === keyBindings.close) onClose();
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
};
